'use client';

import type { FunctionComponent } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';

import SearchInput from './SearchInput';

type Props = {
    id: string;
    pathname: string;
    placeholder?: string;
    filterParam?: string;
    pageParam?: string;
    onChange?: (value: string) => void;
};

const FilterByInput: FunctionComponent<Props> = ({
    id,
    pathname,
    placeholder = 'Căutare',
    filterParam = 'filter',
    pageParam = 'page',
    onChange = null,
}) => {
    const searchParams = useSearchParams();
    const router = useRouter();

    const handleSubmit = (keyword: string) => {
        const params = new URLSearchParams(searchParams?.toString());
        if (!keyword) {
            params.delete(filterParam);
        } else {
            params.set(filterParam, keyword);
        }

        if (pageParam) {
            params.delete(pageParam);
        }

        if (typeof onChange === 'function') {
            onChange(keyword);
        } else {
            router.push(`${pathname}?${params.toString()}`);
        }
    };

    return <SearchInput id={id} onSubmit={handleSubmit} placeholder={placeholder} />;
};

FilterByInput.displayName = 'FilterByInput';

export default FilterByInput;
